import {
  verifyAddress,
  error_codes,
  freeForm,
  globalFreeForm,
  cityState,
  postalCode,
} from '../apis/melissaAPI';

const melissaVerify = (country, fullAddress, complete_callback) => {
  return verifyAddress(country, fullAddress).then((response) => {
    let resultObj = {
      address_not_verified: false,
      city: '',
      address_state: '',
      address_street: '',
      zip: '',
      error_string: '',
    };
    if (response.length != 1) {
      resultObj.address_not_verified = true;
    } else {
      var record = response[0];
      var results = record['Results'];
      results = results.split(',');
      var verified = false;
      var error = false;
      var error_string = '';

      for (let result of results) {
        if (result.startsWith('AV')) {
          result = result.replace('AV', '');
          var level = parseInt(result);
          if (level >= 12) verified = true;
        }
        if (result.startsWith('AE')) {
          var error_code = result.substring(0, 4);
          error = true;
          error_string = error_codes[error_code];
        }
      }
      if (verified && !error) {
        resultObj.address_not_verified = false;
        resultObj.error_string = '';
        var line1 = `${record['PremisesNumber']} ${record['Thoroughfare']}`;
        var line2 = record['AddressLine2'];
        if (line2.startsWith(record['Locality'])) line2 = '';
        else line2 = ', ' + line2;
        resultObj.address_street = `${line1} ${line2}`;
        resultObj.city = record['Locality'];
        resultObj.address_state = record['AdministrativeArea'];
        resultObj.zip = record['PostalCode'];
      } else {
        error_string = 'Could not verify address';
        resultObj.address_not_verified = true;
        resultObj.error_string = error_string;
      }
      if (complete_callback) {
        complete_callback();
      }
      return resultObj;
    }
  });
};

const melissaFreeform = (value) => {
  return freeForm(value, 25)
    .then((data) => {
      let addressList = data['Results']
        ? data['Results'].map((option) => ({
          fullAddress: `${option['Address']['AddressLine1']}, ${option['Address']['City']} ${option['Address']['State']}, ${option['Address']['PostalCode']}`,
          street: option['Address']['AddressLine1'],
          city: option['Address']['City'],
          state: option['Address']['State'],
          zip: option['Address']['PostalCode'],
          list_key: option['Address']['MAK'],
          suiteName: option['Address']['SuiteName'],
          suiteList: option['Address']['SuiteList'],
        }))
        : [];
      return addressList;
    })
    .catch((err) => { });
};

const melissaGlobalFreeForm = (value, country) => {
  return globalFreeForm(value, country, 25)
    .then((data) => {
      let addressList = data['Results']
        ? data['Results'].map((option) => ({
          fullAddress: `${option['Address']['Address1']}, ${option['Address']['Locality']} ${option['Address']['AdministrativeArea']} ${option['Address']['PostalCode']}, ${option['Address']['CountryName']}`,
          country: option['Address']['CountryName'], // Might be needlessly verbose. "United States of America".
          street: `${option['Address']['Premise']} ${option['Address']['Thoroughfare']}`,
          city: option['Address']['Locality'],
          state: option['Address']['AdministrativeArea'],
          zip: option['Address']['PostalCode'],
          list_key: option['Address']['MAK'],
          suiteName: option['Address']['SuiteName'],
          suiteList: option['Address']['SuiteList'],
          subBuilding: option['Address']['SubBuilding'],
        }))
        : [];
      return addressList;
    })
    .catch((err) => { });
};

const melissaCityState = (value) => {
  let zipcode = /\d\d\d\d\d/; // regex matches five numeric digits
  let zip;
  let city;
  let state;
  if (value.match(zipcode) !== null) {
    zip = value.match(zipcode)[0];
    city = value.replace(zipcode, '').trim();
  } else {
    zip = null;
    if (value.includes(',')) {
      let commaIndex = value.indexOf(',');
      city = value.slice(0, commaIndex);
      state = value.slice(commaIndex).trim();
    } else {
      city = value;
    }
  }
  return cityState(city, zip, 25, state)
    .then((data) => {
      let addressList = data['Results']
        ? data['Results'].map((option) => ({
          fullAddress:
            option['Address']['PostalCode'] +
            ' ' +
            option['Address']['City'] +
            ', ' +
            option['Address']['State'],
          city: option['Address']['City'],
          state: option['Address']['State'],
          zip: option['Address']['PostalCode'],
          list_key: option['Address']['PostalCode'],
          suiteName: option['Address']['SuiteName'],
          suiteList: option['Address']['SuiteList'],
        }))
        : [];
      return addressList;
    })
    .catch((err) => { });
};

const melissaPostalCode = (value, country) => {
  return postalCode(value, country)
    .then((data) => {
      let addressList = data['Results']
        ? data['Results'].map((option) => ({
          // Determine if we want city or country
          // fullAddress: `${option['Address']['PostalCode']} ${option['Address']['CityAccepted']}, ${option['Address']['CountryName'] || option['Address']['ISO3166_2'] || option['Address']['ISO3166_3']}`,
          fullAddress: `${option['Address']['PostalCode']} ${option['Address']['Locality']}, ${option['Address']['AdministrativeArea']}`,
          zip: option['Address']['PostalCode'],
          city: option['Address']['Locality'],
          state: option['Address']['AdministrativeArea'],
          list_key: option['Address']['PostalCode'],
          // city: option['Address']['CityAccepted'],
          // country: option['Address']['CountryName'] || option['Address']['ISO3166_2'] || option['Address']['ISO3166_3'],
        }))
        : [];
      return addressList;
    })
    .catch((err) => { });
}

const melissaLookup = (api, value, country) => {
  if (api === 'freeform') return melissaFreeform(value);
  if (api === 'globalfreeform') return melissaGlobalFreeForm(value, country);
  else if (api === 'citystate') return melissaCityState(value);
  else if (api === 'postalcode') return melissaPostalCode(value, country);
};

export {
  melissaVerify,
  melissaLookup,
};
